import React from 'react'
import styled from 'styled-components'
import Footer from './Footer'
import Nav from './Nav'
import GoTopButton from '~shared/GoTopButton'
import { useStreamrTvBanner } from '../../contexts/StreamrTvBannerContext'
import StreamrTvBanner from './StreamrTvBanner'

const Inner = styled.div``

const NavWrapper = styled.div`
    /* Ensure nav content is positioned below the StreamrTvBanner */
    position: relative;
    z-index: 1;
`

const UnstyledLayout = ({
    children = null,
    className,
    goTopButton = (
        <GoTopButton.Floater>
            <GoTopButton />
        </GoTopButton.Floater>
    ),
    nav = <Nav />,
    footer = <Footer />,
}) => (
    <>
        <div className={className}>
            <StreamrTvBanner />
            <NavWrapper>{nav}</NavWrapper>
            {goTopButton}
            <Inner>{children}</Inner>
        </div>
        {footer}
    </>
)

const StyledLayout = styled(UnstyledLayout)`
    background-color: ${({ $backgroundColor = '#fafafa' }) => $backgroundColor};

    /* Add top margin to account for fixed StreamrTvBanner */
    margin-top: ${({ bannerHeight }) => bannerHeight}px;
    transition: margin-top 0.3s ease-in-out;
    will-change: margin-top;
`

const Layout = (props) => {
    const { bannerHeight } = useStreamrTvBanner()

    return <StyledLayout {...props} bannerHeight={bannerHeight} />
}

Object.assign(Layout, {
    Inner,
})

export default Layout
